'use strict';

const TaskRepository = require('my/domain/repository/task');
const TaskCollection = require('my/domain/collection/task');

class TaskCollectionRepository {
    constructor(project) {
        this._project = project;
        this._repo = TaskRepository;
        this._tasks = new TaskCollection([], {
            repository: this._repo
        });
    }

    my() {
        return this._tasks;
    }
}

module.exports = new TaskCollectionRepository();



// WEBPACK FOOTER //
// ./my/domain/repository/task-collection.js